import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/atoms/select';

interface DataTableSelectFilterOption {
  value: string;
  label: string;
}

interface DataTableSelectFilterFieldProps {
  value: string;
  onValueChange: (value: string) => void;
  placeholder: string;
  options: DataTableSelectFilterOption[];
}

export function DataTableSelectFilterField({
  value,
  onValueChange,
  placeholder,
  options,
}: DataTableSelectFilterFieldProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className="h-9 w-full min-w-0 text-sm">
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value} className="text-sm">
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
